export function Lerp(x, y, t) {
  return x + t * (y - x);
}
export function NormalizeByRange(target, min, max) {
  return (target - min) / (max - min);
}
export function RandomRange(min, max) {
  return ~~(Math.random() * (max - min + 1)) + min;
}
;
export function Normalize2D(vector) {
  let vi = Math.sqrt(Math.pow(vector.x, 2) + Math.pow(vector.y, 2));
  let normalized = {
    x: vector.x / vi,
    y: vector.y / vi
  };
  return normalized;
}
export function VectorNumAdd(vector, scale) {
  return {
    x: vector.x + scale,
    y: vector.y + scale
  };
}
export function VectorNumScale(vector, scale) {
  return {
    x: vector.x * scale,
    y: vector.y * scale
  };
}
export function VectorDistance(a, b) {
  return Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
}
export function VectorMaginitude(a) {
  return Math.sqrt(Math.pow(a.x, 2) + Math.pow(a.y, 2));
}
export function VectorAdd(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
export function VectorMinus(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
export function VectorToArray(v) {
  return [v.x, v.y];
}
export function ArrayToVector(array) {
  return {x: array[0], y: array[1]};
}
export function Clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
;
export function GetImagePromise(imagePath) {
  return new Promise((resolve) => {
    const im = new Image();
    im.crossOrigin = "anonymous";
    im.src = imagePath;
    im.onload = () => resolve(Object.assign(im));
    return im;
  });
}
export function GetImageOnTheFly(imagePath, oncompleteCallback) {
  const im = new Image();
  im.crossOrigin = "anonymous";
  im.src = imagePath;
  im.onload = () => {
    oncompleteCallback();
  };
  return im;
}
export function GetRelativeURL(url) {
  return url.replace(/^(?:\/\/|[^/]+)*\//, "");
}
export function StringToVector(vectorString) {
  let splits = vectorString.split(",");
  return {
    x: parseFloat(splits[0]),
    y: parseFloat(splits[1])
  };
}
export function RoundToDecimal(value, decimal) {
  let d = Math.pow(10, decimal);
  return Math.round(value * d) / d;
}
export function IsMobileDevice() {
  var ua = navigator.userAgent;
  return /Android|webOS|iPhone|iPad|iPod/i.test(ua);
}
